import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { useTranslation } from 'react-i18next';

export function CreateTermineSubmitButton() {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();

  return (
    <form.AppForm>
      <div className="block md:hidden">
        <form.SubmitButton
          buttonText={t('domain.termine.form.fertig')}
          variant="ghost-primary"
          size="sm"></form.SubmitButton>
      </div>
      <div className="hidden md:block">
        <form.SubmitButton buttonText={t('domain.termine.form.fertig')} />
      </div>
    </form.AppForm>
  );
}
